import React, { useEffect, useState } from "react";
import Logo from "../img/logoBay.png";
import PortadaMudanzaDesktop from "../img/mudanza-desktop-dos2.webp";
import PortadaMudanzaMobile from "../img/mudanza-mobile-uno1.webp";
import Especialista from "../img/especialistas.png";
import Ok from "../img/ok.png";
import PortadaGuardaDesktop from "../img/guarda-desk-dos2.webp";
import PortadaGuardaMobile from "../img/guardamuebles-mobile-uno1.webp";
import "./Form";
import "../style/Home.css";
const Home = () => {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowImage(true), 50);
  }, []);

  const scrollToForm = () => {
    const formSection = document.getElementById("formu"); // 👈 ID del form
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="home-container">
      <div className="mudanzaBanners">
        <img
          className={`home-image desktop ${showImage ? "show" : ""}`}
          src={PortadaMudanzaDesktop}
          alt="Mudanza"
        />
        <img
          className={`home-image mobile ${showImage ? "show" : ""}`}
          src={PortadaMudanzaMobile}
          alt="Mudanza"
        />
        {/* Botón mobile centrado debajo de la imagen */}
        {showImage && (
          <div className="mobile-button-container">
            <button onClick={scrollToForm}>PEDÍ PRESUPUESTO</button>
          </div>
        )}

        {/* Contenedor superpuesto */}
        <div className="banner-overlay">
          <img className="logo-banner" src={Logo} alt="Logo" />
          <h2>MUDANZAS</h2>
          <p>Fletes</p>
          <p>Servicio de embalaje</p>
          <p>Elevación por soga</p>
          <p>Armado y desarmado</p>
          <p>Personal para carga y descarga</p>
          <button onClick={scrollToForm}>PEDÍ PRESUPUESTO</button>
        </div>
      </div>

      <div className="cardsBanners">
        <div className="card">
          <img src={Especialista} alt="Especialista" />
          <h2>Somos especialistas</h2>
          <p>Contamos con un equipo de expertos en mudanzas</p>
        </div>
        <div className="card">
          <img src={Ok} alt="responsabilidad" />
          <h2>Responsabilidad</h2>
          <p>
            Entregamos todos los bienes en las mismas condiciones que los
            recibimos
          </p>
        </div>
      </div>

      <div className="guardaBanners">
        <img
          className={`home-image desktop ${showImage ? "show" : ""}`}
          src={PortadaGuardaDesktop}
          alt="Guardamuebles"
        />
        <img
          className={`home-image mobile ${showImage ? "show" : ""}`}
          src={PortadaGuardaMobile}
          alt="Guardamuebles"
        />
        {/* Botón mobile centrado debajo de la imagen */}
        {showImage && (
          <div className="mobile-button-container">
            <button onClick={scrollToForm}>PEDÍ PRESUPUESTO</button>
          </div>
        )}

        {/* Contenedor superpuesto */}
        <div className="banner-overlay-guarda">
          <img className="logo-banner-guarda" src={Logo} alt="Logo" />
          <h2>GUARDAMUEBLES</h2>
          <p>Ofrecemos un espacio</p>
          <p>cuidado y seguro para tus bienes.</p>
          <p>Lugar libre de polvo para conservar</p>
          <p>sus objetos</p>
          <p>en perfecto estado</p>
          <button onClick={scrollToForm}>PEDÍ PRESUPUESTO</button>
        </div>
      </div>
    </div>
  );
};

export default Home;
